import React from 'react'
import TransactionDetailTable from './transactions/TransactionDetailTable'

const TransactionPage = () => {
  return (
    <>
    <TransactionDetailTable />
    </>
  )
}

export default TransactionPage